'use client'

import * as React from 'react'
import Image from 'next/image'
import type { IndustryCreative } from '@/lib/copy/industry-creatives'

export function IndustryHotspotCard({ creative }: { creative: IndustryCreative }) {
  const [hovered, setHovered] = React.useState(false)

  return (
    <div
      className="relative h-44 w-full overflow-hidden"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <Image
        src={creative.hero}
        alt={creative.name}
        fill
        className={`object-cover transition-transform duration-500 ${hovered ? 'scale-105' : 'scale-100'}`}
        sizes="(min-width: 1024px) 33vw, (min-width: 768px) 50vw, 100vw"
      />
      {/* Overlay */}
      <div
        className="absolute inset-0 bg-black transition-opacity duration-300"
        style={{ opacity: hovered ? 0.3 : 0.15 }}
      />

      {/* Pins */}
      {creative.pins.slice(0, 2).map((pin, i) => (
        <div
          key={pin.name}
          className="absolute"
          style={{ left: `${pin.x}%`, top: `${pin.y}%`, transform: 'translate(-50%,-50%)' }}
        >
          {/* Pulse ring */}
          <span
            className="absolute rounded-full animate-ping"
            style={{
              inset: -6,
              background: '#C8FF52',
              opacity: 0.45,
              animationDuration: `${1.6 + i * 0.5}s`,
            }}
          />
          {/* Dot */}
          <span
            className="relative z-10 flex h-5 w-5 items-center justify-center rounded-full border-2 border-white text-[9px] font-bold shadow-md"
            style={{ background: '#C8FF52', color: '#0F1419' }}
          >
            {i + 1}
          </span>
          {/* Tooltip on hover */}
          {hovered && (
            <span
              className="absolute left-6 top-1/2 -translate-y-1/2 whitespace-nowrap rounded-lg px-2 py-[3px] text-[9px] font-semibold leading-tight shadow-lg"
              style={{ background: '#0F1419', color: '#fff', zIndex: 20 }}
            >
              {pin.name} · {pin.price}
            </span>
          )}
        </div>
      ))}

      {/* Lift badge */}
      <div className="absolute bottom-2 right-2 rounded-full bg-black/65 px-2 py-0.5 text-[10px] font-bold text-[#C8FF52] backdrop-blur-sm">
        {creative.liftNum} {creative.liftLabel}
      </div>
    </div>
  )
}
